import { Stage } from "konva/lib/Stage";
import { Point } from "@/stores/line";
import Konva from "konva";

interface UpdateStageArgs {
  height?: number;
  width?: number;
  scale?: number;
  position?: Point;
  animate?: boolean;
  duration?: number;
  easing?: string;
}

export class EditorStage {
  stage: Stage;
  bgStage: Stage;
  updateStatus = "idle";
  updateStageArgs: UpdateStageArgs = {};

  constructor(stage: Stage, bgStage: Stage) {
    this.stage = stage;
    this.bgStage = bgStage;
  }

  updateStages(args: UpdateStageArgs = {}) {
    if (!this.bgStage || !this.stage) return;

    this.updateStageArgs = { ...this.updateStageArgs, ...args };
    if (this.updateStatus === "executing") return;

    this.updateStatus = "executing";
    const {
      height,
      width,
      scale,
      position,
      animate = false,
      duration = 0.15,
      easing = "easeOutBack",
    } = this.updateStageArgs;

    const stages = [this.stage.getStage(), this.bgStage.getStage()];

    if (animate) {
      stages.forEach((stage) => {
        const tweenConfig: any = {
          node: stage,
          duration: duration,
          onFinish: () => {
            this.updateStatus = "idle";
            this.updateStageArgs = {};
          },
        };

        if (width !== undefined) tweenConfig.width = width;
        if (height !== undefined) tweenConfig.height = height;
        if (scale !== undefined) tweenConfig.scaleX = scale;
        if (scale !== undefined) tweenConfig.scaleY = scale;
        if (position !== undefined) {
          tweenConfig.x = position.x;
          tweenConfig.y = position.y;
        }

        if (easing === "easeOutBack") {
          tweenConfig.easing = Konva.Easings.BackEaseOut;
        } else if (easing === "easeInOut") {
          tweenConfig.easing = Konva.Easings.EaseInOut;
        } else {
          tweenConfig.easing = Konva.Easings.EaseOut;
        }

        new Konva.Tween(tweenConfig).play();
      });
    } else {
      stages.forEach((stage) => {
        if (width) stage.width(width);
        if (height) stage.height(height);
        if (scale) stage.scale({ x: scale, y: scale });
        if (position) stage.position(position);
      });

      this.updateStatus = "idle";
      this.updateStageArgs = {};
    }
  }
}
